const unit = 4; // pixels

export const XS = '4px';
export const S = '8px';
export const M = '16px';
export const L = '24px';
export const XL = '24px';

export const times = (n: number): string => `${unit * n}px`;
